<template>
  <!-- :style="{ height:  screenHeight > 0  ? `${screenHeight}px` : `auto` }" -->
  <div class="container-fluid px-3 pl-md-5 pr-md-2">
    <div class="row mt-3 p-0">
      <div class="col-12 col-xl-3 text-center mb-4">
        <img src="/images/adventures/logo-va.png" class="logo-image p-0" />
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import Sidebar from "@/components/Tour/Sidebar";
import Timmer from "@/components/Tour/Timmer";

import _ToursShopping from "@/store/helpers/tours/shopping";
import _GlobalHelper from "@/store/helpers/global";

import Search from "@/pages/tours/Search";
import Detail from "@/pages/tours/Detail";

import { mapGetters } from "vuex";

export default {
  name: "root-tours",
  components: {
    "tour-sidebar": Sidebar,
    Timmer: Timmer,
    Search,
    Detail,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      screenHeight: null,
      mobile: false,
      step: null,
    };
  },

  computed: {
    ...mapGetters({
      loading: _GlobalHelper.getters.loading,
      shopping: _ToursShopping.getters.shopping,
    }),

    isReservation() {
      return this.$route.name === "tours-reservation";
    },
  },

  watch: {
    loading(value) {
      if (!value.show) {
        this.screenHeight = 0;
      }
    },
  },

  methods: {
    setViewport: function () {
      if (window.innerWidth > 1200) {
        this.mobile = false;
      } else {
        this.mobile = true;
      }

      // let changeWindowSize = 375
      // let viewportContent = "width=device-width,initial-scale=1.0"
      // if (window.innerWidth < changeWindowSize) {
      //     viewportContent = "width=375,user-scalable=no,viewport-fit=cover"
      // }

      // console.log(viewportContent)

      //document.querySelector("meta[name='viewport']").setAttribute("content", viewportContent)
    },
  },

  created() {
    window.addEventListener("resize", this.setViewport);
    this.setViewport();
  },

  mounted() {
    // console.log(this.windowWidth);
  },

  beforeDestroy() {},

  destroyed() {
    window.removeEventListener("resize", this.setViewport);
  },
};
</script>

<style lang="scss">
.logo-image {
  width: 95% !important;
}
.responsive-desktop {
  display: block;
}

.responsive-mobile {
  display: none;
}

@media (max-width: 1200px) {
  .logo-image {
    width: 60% !important;
  }
}

@media (max-width: 600px) {
  .logo-image {
    width: 70% !important;
  }
}
@media (max-width: 450px) {
  .logo-image {
    width: 80% !important;
  }
}

.mainSection {
  & {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
}
</style>